import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import PendoLib, { LEARNER_API_KEY } from 'js/lib/pendo';
import { useParams } from 'js/lib/useRouter';
import user from 'js/lib/user';

import EnterpriseLearningPathPageRootContent from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseLearningPathPageRootContent';
import EnterpriseLearningPathPageDataProvider from 'bundles/enterprise-learning-path-description-page/providers/pages/EnterpriseLearningPathPageDataProvider';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';
import EnterpriseOrgScopedPageTemplateWrapper from 'bundles/unified-common/providers/org-scoped/EnterpriseOrgScopedPageTemplateWrapper';
import EnterpriseOrgScopedModalManagerProvider from 'bundles/unified-common/providers/org-scoped/modals/EnterpriseOrgScopedModalManagerProvider';

const EnterpriseLearningPathPageRoot = () => {
  const { programSlug, orgSlug } = useParams();
  // Org-scoped chrome is determined by the route (orgSlug is present only on /organizations/... URLs),
  // not the org-scoped-home experiment flag — so the page chrome always matches the mounted data chain.
  // On /programs/... the non-org wrapper's guard handles redirecting opted-in learners to the org URL.
  const isOrgScoped = Boolean(orgSlug);

  React.useEffect(() => {
    try {
      PendoLib.init(
        {
          visitor: {
            id: user.get().external_id,
            isLoggedIn: user.isAuthenticatedUser(),
            isCourserian: user.isCourserian(),
          },
          account: {
            isEnterprise: true,
            ...(isOrgScoped ? { slug: orgSlug ?? '' } : { programSlug: programSlug ?? '' }),
          },
        },
        LEARNER_API_KEY
      );
    } catch {
      // do nothing
    }
  }, [isOrgScoped, orgSlug, programSlug]);
  const content = <EnterpriseLearningPathPageRootContent />;
  return (
    <div data-e2e="enterprise-learning-path-page">
      <EnterpriseLearningPathPageDataProvider>
        {isOrgScoped ? (
          <EnterpriseOrgScopedModalManagerProvider>
            <EnterpriseOrgScopedPageTemplateWrapper hideAdminImpersonationBanner>
              {content}
            </EnterpriseOrgScopedPageTemplateWrapper>
          </EnterpriseOrgScopedModalManagerProvider>
        ) : (
          <EnterprisePageTemplateWrapper>{content}</EnterprisePageTemplateWrapper>
        )}
      </EnterpriseLearningPathPageDataProvider>
    </div>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'enterprise_learning_path_description_page',
      page: 'enterprise_learning_path_page',
    },
  }))
)(EnterpriseLearningPathPageRoot);
